<template>
    <div>
      <div class="text-right font-weight-bold mb-3" >
<!--            <span class="border-right pr-3">No. of School Days: {{attendanceData}}</span>
            <span class="pl-3">No. of Holidays: {{attendanceData}}</span>-->
      </div>
      <a-spin :spinning="loading">
        <div class="py-5 text-center" v-if="!enrollAttendanceData">
          <a-tag color="pink">Select a class or search by student name/code to view attendance report</a-tag>
        </div>
        <!-- Check if attendanceData is not null but attendanceData.students is empty -->
        <div class="py-5 text-center" v-else-if="enrollAttendanceData.length === 0">
          <a-tag color="red">No students available</a-tag>
        </div>
        <div v-else class="table-responsive">
          <table class="table table-bordered table-sm">
            <thead>
              <tr class="text-center">
                <th>#</th>
                <th>S. Code</th>
                <th>Name</th>
                <th>Date</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Late Status</th>
                <th>Status</th>
<!--            <th>Percentage Absent (%)</th>-->
              </tr>
            </thead>
            <tbody>
             <tr class="text-center" v-for="(enrollAttendance, index) in enrollAttendanceData" :key="enrollAttendance.id">
                <th>{{ index + 1 }}</th>
                <td>{{ enrollAttendance.student_code }}</td>
                <td class="text-left pl-3">{{ enrollAttendance.roll_no ? `(${enrollAttendance.roll_no})` : '' }} {{ enrollAttendance.student.first_name + ' ' + enrollAttendance.student.last_name }}</td>
                <td>{{ enrollAttendance.student.attendance.length !=0 ? enrollAttendance.student.attendance[0].date : null }}</td>
                <td>{{ enrollAttendance.student.attendance.length !=0  ? enrollAttendance.student.attendance[0].start_time : null }}</td>
                <td>{{ enrollAttendance.student.attendance.length !=0  ? enrollAttendance.student.attendance[0].end_time : null }}</td>
                <td>
                  <span v-if="enrollAttendance.student.attendance.length !=0 && enrollAttendance.student.attendance[0].late_duration">
                    <a-tag :color="'orange'">Late</a-tag>

                  </span>
                </td>
                <td>
                  <span v-if="enrollAttendance.student.attendance.length !=0">
                    <a-tag :color="enrollAttendance.student.attendance[0].status === 1? 'red': 'green'">{{ enrollAttendance.student.attendance[0].status === 1 ? 'Absent' : 'Present' }}</a-tag>
                  </span>
                </td>
             </tr>
<!--              <tr v-if="!attendanceData.students.length">
                <td :colspan="attendanceData.dates.length + 2">
                  <no-data text="No Students" />
                </td>
              </tr>-->
            </tbody>
          </table>
        </div>
      </a-spin>

    </div>
  </template>
<script>
// import { includes } from 'lodash'
import moment from 'moment'

// import NoData from '@/components/layout/NoData/index'

export default {
  name: 'AttendanceDetailReportTable',
  components: {
    // NoData,
  },
  props: {
    enrollAttendanceData: {
      type: Array,
      default: () => [],
    },
    overallData: {
      type: Object,
      default: () => ({}),
    },
    attendanceDate: String,
    additionalData: Object,
    rolesetting: { type: Object },
  },
  data: function() {
    return {
      infoVisible: false,
      loading: false,
      selectedStudents: [],
      selectedLeaveStudents: [],
      holidays: [],
      classHasStudents: false,
    }
  },
  watch: {
    // attendanceData: function (val) {
    //   this.selectedStudents = []
    //   this.holidays = val ? val.holidays.map(element => {
    //     if (!element.in_attendance) {
    //       return moment(element).format('YYYY-MM-DD')
    //     }
    //   }) : []
    //   this.selectedStudents = val ? val.absentees : []
    //   this.selectedLeaveStudents = val ? val.on_leave : []
    //   this.infoVisible = val ? !val.attendance_exists && !includes(this.holidays, this.attendanceDate) : false
    //   console.log(!val.attendance_exists && !includes(this.holidays, this.attendanceDate))
    // },
  },
  methods: {
    moment,
    // handleCellClick: function(studentId, date) {
    //   // Allow only selected date
    //   if (date.in_attendance && date.date === this.attendanceDate) {
    //     if (!this.selectedStudents.includes(studentId) && !this.selectedLeaveStudents.includes(studentId)) {
    //       this.selectedStudents.push(studentId)
    //     } else if (this.selectedStudents.includes(studentId) && !this.selectedLeaveStudents.includes(studentId)) {
    //       const newSelectedStudents = this.selectedStudents.filter(value => value !== studentId)
    //       this.selectedStudents = newSelectedStudents
    //       this.selectedLeaveStudents.push(studentId)
    //     } else {
    //       const newSelectedStudents = this.selectedStudents.filter(value => value !== studentId)
    //       this.selectedStudents = newSelectedStudents
    //       const newSelectedLeaveStudents = this.selectedLeaveStudents.filter(value => value !== studentId)
    //       this.selectedLeaveStudents = newSelectedLeaveStudents
    //     }
    //   }
    // },
    // checkAttendanceStatus(studentAttendance, date) {
    //   let status
    //   studentAttendance.forEach(element => {
    //     if (element.date === date && element.status === 2) status = 'leave'
    //     if (element.date === date && element.status === 1) status = 'absent'
    //     if (element.date === date && element.status === 0) status = 'present'
    //   })
    //   return status
    // },
    // isInSelectedStudents (studentId) {
    //   return this.selectedStudents.includes(studentId)
    // },
    // isInSelectedLeaveStudents (studentId) {
    //   return this.selectedLeaveStudents.includes(studentId)
    // },
    // handleMarkAllAbsent () {
    //   this.selectedLeaveStudents = []
    //   this.selectedStudents = this.attendanceData.students.map(element => {
    //     return element.student_id
    //   })
    // },
    // handleMarkAllPresent () {
    //   this.selectedStudents = []
    //   this.selectedLeaveStudents = []
    // },
    // handleAttendanceDateClick(date) {
    //   if (this.attendanceDate === date && this.attendanceData.students.length !== 0) {
    //     // this.$refs.attendanceByRoll.showModal()
    //     this.$eventBus.$emit('openAttendanceAddByRollModal')
    //   }
    //   if (this.attendanceData.students.length === 0) {
    //     this.$message.warning('You cannot add attendance! No student found in this class!')
    //   }
    // },
    // handleBulkStudentSelect(studentIds) {
    //   this.selectedStudents = studentIds
    //   this.handleSubmit()
    // },
    // handleSubmit() {
    //   if (!this.holidays.includes(this.attendanceDate) && moment(this.attendanceDate).day() !== 0) {
    //     this.$confirm({
    //       title: `Are you sure?`,
    //       content: `Click Ok to submit attendance for ${moment(this.attendanceDate).format('DD-MM-YYYY')}`,
    //       onOk: () => {
    //         this.loading = true
    //         this.$http
    //           .post('/api/attendance', {
    //             date: this.attendanceDate,
    //             session_id: this.additionalData.sessionId,
    //             class_id: this.additionalData.classId,
    //             section_id: this.additionalData.sectionId,
    //             absentees: this.selectedStudents,
    //             on_leave: this.selectedLeaveStudents,
    //           })
    //           .then(({ data }) => {
    //             this.loading = false
    //             this.$notification['success']({
    //               message: `Attendance submitted successfully!`,
    //               description: `Attendance for ${moment(this.attendanceDate).format('DD-MM-YYYY')} has been submitted!`,
    //             })
    //             this.selectedStudents = []
    //             this.$emit('submitted')
    //           })
    //           .catch(error => {
    //             this.loading = false
    //             this.$neoNotify.error(error)
    //           })
    //       },
    //       onCancel: () => {
    //         this.loading = false
    //       },
    //     })
    //   }
    // },
  },
}
</script>
